import { IPlaneFrame, PlaneLine, PlaneRadiusVector } from './index';

export class PlaneLabel {
    public textFrame: IPlaneFrame;
    public trackLine: PlaneLine;

    constructor(public text: string, public position: PlaneRadiusVector, public angle: number, public isAngleLabel: boolean) {
    }
}
